var React = require('react');
var css = require('./module.scss');

var TabPage = React.createClass({

    onActiveChange: function(index) {
        index != this.props.active && this.props.onChange(index);
    },

    render: function() {
        var cls = ['fp-tabPage', this.props.className];
        var nav = this.props.nav || [];
        var width = this.props.width || 80;
        var _this = this;

        return (
            <div className={cls.join(' ')}>
                <div className="fp-tabpage-nav tClear">
                    {
                        nav.map(function(item, index, arr) {
                            let cls = ['fp-tab-item-wrap'];
                            if (index == _this.props.active) {
                                cls.push('fp-tab-active');
                            }
                            if (index == nav.length - 1) {
                                cls.push('fp-last-item');
                            }
                            return <div className={cls.join(' ')} key={index}>
                                <strong onClick={_this.onActiveChange.bind(this, index)}
                                    style={{width: width}}>
                                    {item}
                                </strong>
                            </div>;
                        })
                    }
                </div>
                <div className='fp-tabPage-box'>
                    {
                        React.Children.map(this.props.children, function(child, index) {
                            return (
                                <div className={index == _this.props.active ? '' : 'fp-tab-isHidden'}>
                                    {child}
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
});

module.exports = TabPage;



// WEBPACK FOOTER //
// ./component/tabPage/index.js